module.exports = __webpack_public_path__ + "static/media/Mannings.368a2f28.png";